<template>
  <div class="md-content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1 v-if="isEditMode">
          Edit Enhancer v2
        </h1>
        <h1 v-else>
          Create Enhancer v2
        </h1>

        <md-progress-bar v-if="isLoading" />
        <md-content
          v-else
          class="block"
        >
          <h3>General info</h3>

          <two-language-input
            v-model="enhancer.title"
            label="Title"
            inline
          />

          <two-language-input
            v-model="enhancer.description"
            label="Description"
            multiline
          />

          <two-language-input
            v-model="enhancer.additional_info"
            label="Additional info"
            multiline
            optional
          />

          <label class="inlineFieldLabel">Access</label>
          <md-field class="field">
            <md-select v-model="enhancer.shortcuts_access">
              <md-option value="SHORTCUTS_ACCESS_FREE">
                Free
              </md-option>
              <md-option value="SHORTCUTS_ACCESS_PREMIUM">
                Premium
              </md-option>
            </md-select>
          </md-field>

          <md-switch v-model="outerEnhancer.is_enabled">
            Enabled
          </md-switch>

          <br>

          <md-switch v-model="outerEnhancer.sensitive">
            Sensitive
          </md-switch>
        </md-content>

        <md-content
          v-if="!isLoading"
          class="block"
        >
          <h3>Mechanics</h3>

          <label class="inlineFieldLabel">Type</label>
          <md-field class="field">
            <md-select v-model="enhancer.show_type">
              <md-option value="ENHANCER_SHOW_TYPE_DEFAULT">
                Default
              </md-option>
              <md-option value="ENHANCER_SHOW_TYPE_TOGGLE">
                Toggle
              </md-option>
              <md-option value="ENHANCER_SHOW_TYPE_SELECT">
                Select
              </md-option>
            </md-select>
          </md-field>

          <md-content class="md-elevation-1 block">
            <h5>Options</h5>

            <two-language-input
              v-model="enhancer.enhancer_config.title"
              label="Title"
              inline
            />

            <two-language-input
              v-model="enhancer.enhancer_config.description"
              label="Description"
              multiline
            />

            <label class="inlineFieldLabel">Enhancer type</label>
            <md-field class="field">
              <md-select v-model="enhancer.enhancer_config.enhancer_type">
                <md-option value="ENHANCER_TYPE_DNS_SERVER">
                  DNS Server
                </md-option>
              </md-select>
            </md-field>
          </md-content>
        </md-content>

        <md-button
          class="md-primary"
          @click="submit"
        >
          Save
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
  import TwoLanguageInput from "../../components/Forms/Fields/TwoLanguageInput";

  const enhancerMock = {
    "enhancer": {
      "enhancer": {
        "title": {
          "en": "string",
          "uk": "string"
        },
        "description": {
          "en": "string",
          "uk": "string"
        },
        "additional_info": {
          "en": "string",
          "uk": "string"
        },
        "shortcuts_access": "SHORTCUTS_ACCESS_FREE",
        "show_type": "ENHANCER_SHOW_TYPE_DEFAULT",
        "enhancer_config": {
          "title": {
            "en": "string",
            "uk": "string"
          },
          "description": {
            "en": "string",
            "uk": "string"
          },
          "enhancer_type": "ENHANCER_TYPE_DNS_SERVER",

          // don't know what to do here
          "dns_configuration": {
            "nameservers": [
              {
                "default_dns_configuration": {
                  "address": "string"
                }
              }
            ]
          }
        },
      },
      "sequence_index": 0,
      "is_enabled": true,
      "shortcut_group_ids": ["string"],
      "sensitive": true
    }
  };

  export default {
    name: "EditShortcutGroupV2",
    components: { TwoLanguageInput },
    data() {
      return {
        isLoading: true,
        isEditMode: this.$route.path.includes("edit"),

        enhancer: {},
        outerEnhancer: {}
      };
    },
    mounted(){
      if (this.isEditMode) {
        this.fetchEnhancer();
      } else {
        this.initializeEmptyEnhancer();
      }
      this.isLoading = false;
    },
    methods: {
      initializeEmptyEnhancer() {
        this.enhancer = {
          title: { en: "", uk: ""},
          description: { en: "", uk: ""},
          additional_info: { en: "", uk: ""},
          shortcuts_access: "SHORTCUTS_ACCESS_FREE",
          show_type: "ENHANCER_SHOW_TYPE_DEFAULT",
          enhancer_config: {
            title: { en: "", uk: ""},
            description: { en: "", uk: ""},
            enhancer_type: "ENHANCER_TYPE_DNS_SERVER",

            // ???????
            "dns_configuration": {
              "nameservers": [
                {
                  "default_dns_configuration": {
                    "address": "string"
                  }
                }
              ]
            }
          },
        };
        this.outerEnhancer = {
          is_enabled: false,
          sensitive: false,
        };
      },
      fetchEnhancer() {
        this.enhancer = enhancerMock.enhancer.enhancer;
      },
      submit() {
        if (!this.isEditMode) {
          this.createEnhancer();
        }
      },
      createEnhancer () {
        this.$http.post("/v1/admin/system/enhancer/create", {
          enhancer: {
            ...this.outerEnhancer,
            enhancer: this.enhancer
          }
        })
          .then(() => {
            this.$notify({
              group: "foo",
              title: "Enhancer created",
            });
            window.location.href = "/shortcuts/v2/enhancers";
          })
          .catch(err => {
            console.error(err);
            this.$notify({
              group: "foo",
              title: "Enhancer creation failed: " + err,
            });
            this.loading = false;
          });
      }
    }
  };
</script>
<style scoped lang="scss">
  .block {
    padding: 20px;
    max-width: 750px;

    h3 {
      margin: 0 0 20px;
    }

    & + & {
      margin: 40px 0 0;
    }
  }

  .inlineFieldLabel {
    display: block;
    margin: 0 0 -20px;
  }

  .spacer {
    margin: 20px 0 0;
  }
</style>
